module.exports = __webpack_public_path__ + "img/vol-my.086b73e0.png";